import { Injectable } from '@angular/core';
import { SearchLiteraturesAdapter } from './search-literatures.adapter';
import { BehaviorSubject, take } from 'rxjs';
import { SearchLiteraturesRequest } from './search-literatures.model';
import { initialStatus, loadingStatus } from '../../../../../core/models/request-status.model';

@Injectable({
  providedIn: 'root',
})
export class SearchLiteraturesService {
  protected searchRequest$ = new BehaviorSubject<SearchLiteraturesRequest>({ ...initialStatus });

  constructor(private searchLiteraturesAdapter: SearchLiteraturesAdapter) {}

  get() {
    return this.searchRequest$.asObservable();
  }

  set(response: SearchLiteraturesRequest) {
    this.searchRequest$.next(response);
  }

  fetch(query: string, pageNumber: number) {
    this.set(loadingStatus);

    this.searchLiteraturesAdapter
      .fetch(query, pageNumber)
      .pipe(take(1))
      .subscribe(searchRequest => {
        this.set(searchRequest);
      });
  }
}
